import React, { useState } from "react";
import styles from "./addproduct.module.scss";
import Proptypes from "prop-types";
import StepThreeProgress from "../../../../assets/images/brand-steps-progress-indicator/step-three.svg";
import Textfield from "../../../Shared/Textfield";
import Button from "../../../Shared/Button";

const StepThree = ({
  handleChange,
  toggle,
  setStep,
  step,
  setShowEPCWarning,
  handleSubmit,
  formData,
  isEdit,
}) => {
  const [errors, setErrors] = useState({
    Ingredients: "",
    ReturnPolicy: "",
    ShippingInformation: "",
    Weight: "",
    SafetyInformation: "",
  });

  console.log(errors, "errors 50");
  return (
    <>
      <div className={styles["progress_container"]}>
        <div className={styles["progress_container_indicator"]}>
          <img src={StepThreeProgress} width={232} height={42} alt="progress" />
        </div>
      </div>
      <div
        className={`${styles["header_container"]} ${styles["header_steptwothree"]}`}
      >
        <p className={styles["header_heading"]}>
          {isEdit ? "Edit" : "Add"} product
        </p>
      </div>
      <div className={styles["label_container"]}>
        Let’s get a little bit of info on the product (* indicates that it can
        not be changed later)
      </div>

      <div className={styles["steptwothree_fields_container"]}>
        <Textfield
          type="text"
          placeholder="Ingredients"
          name="Ingredients"
          id="Ingredients"
          onChange={handleChange}
          error={errors?.Ingredients}
          touched={errors?.Ingredients}
          value={formData?.values?.Ingredients}
          className={styles["input_field_container"]}
        />
        <Textfield
          type="text"
          placeholder="Return Policy (insert link):"
          name="ReturnPolicy"
          id="ReturnPolicy"
          onChange={handleChange}
          error={errors?.ReturnPolicy}
          touched={errors?.ReturnPolicy}
          value={formData?.values?.ReturnPolicy}
          className={`${styles["input_field_container"]}`}
        />
        <Textfield
          type="text"
          placeholder="Shipping Information"
          name="ShippingInformation"
          id="ShippingInformation"
          onChange={handleChange}
          error={errors?.ShippingInformation}
          touched={errors?.ShippingInformation}
          value={formData?.values?.ShippingInformation}
          className={`${styles["input_field_container"]}`}
        />
        <Textfield
          type="text"
          placeholder="Weight (g)"
          name="Weight"
          id="Weight"
          onChange={handleChange}
          error={errors?.Weight}
          touched={errors?.Weight}
          value={formData?.values?.Weight}
          className={`${styles["input_field_container"]}`}
        />

        <Textfield
          type="textarea"
          placeholder="Safety Information"
          name="SafetyInformation"
          id="SafetyInformation"
          onChange={handleChange}
          error={errors?.SafetyInformation}
          touched={errors?.SafetyInformation}
          value={formData?.values?.SafetyInformation}
          className={`${styles["input_field_container"]} ${styles["additional_info_text_area_container"]}`}
        />
      </div>

      <div className={styles["buttons_container"]}>
        <div>
          <Button
            className={`${styles["button_cancel"]} ${styles["steptwothree_buttons_layout"]}`}
            onClick={toggle}
            text={"Cancel"}
          />
        </div>
        <div>
          <Button
            className={`${styles["button_active"]} ${styles["steptwothree_buttons_layout"]}`}
            onClick={() => {
              const fields = ["ReturnPolicy", "ShippingInformation", "Weight", "SafetyInformation"];
              const errorsObj = fields.reduce((acc, field) => {
                if (!formData?.values[field]) {
                  acc[field] = "Required";
                }
                return acc;
              }, {
                Ingredients: formData.Ingredients ? "Required" : "",
              });

              setErrors(errorsObj);

              if (
                fields.every(field => formData?.values[field]) &&
                formData?.values?.Ingredients
              ) {
                if (formData?.values?.GlobalTradeItemNumber) {
                  handleSubmit();
                  setShowEPCWarning(false);
                } else {
                  setShowEPCWarning(true);
                  setStep(step + 1);
                }
              }
            }}
            text={"Submit"}
          />
        </div>
      </div>
    </>
  );
};

StepThree.propTypes = {
  handleChange: Proptypes.func,
  toggle: Proptypes.func,
  setStep: Proptypes.func,
  step: Proptypes.number,
  setShowEPCWarning: Proptypes.func,
  handleSubmit: Proptypes.func,
  formData: Proptypes.object,
  isEdit: Proptypes.bool,
};
export default StepThree;
